import React from 'react';
import PropTypes from 'prop-types';
import configs from 'configs';

import { Card, Tag } from 'antd';
import TrafficLights from '../PrescoringTool/trafficlights';
import { ToggleButton, DropdownMenu } from '../UIKit';
import 'antComponentsStyle';
import './styles.scss';
import {FormattedMessage} from "react-intl";
import messages from "./messages";

class CarItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      image,
      brand,
      reference_code,
      model,
      version,
      target,
      monthlyRate,
      deposit,
      duration,
      distance,
      bundle,
      highlighted,
      suggested,
      catalogSelected,
      tag,
      secondary_tag,
      stockAvailability,
      delivery_time_label,
      color,
      sustainabilityIndex,
      status,
      onStatusButton,
      onCloneButton,
      link,
      isCustom,
      isOwned,
    } = this.props;

    const allowedLabels = [tag, delivery_time_label, secondary_tag, bundle].filter(
      label => label && label.length > 0
    );

    let firstLabel = allowedLabels[0] || null;
    let secondLabel = null;

    if (catalogSelected && firstLabel === 'Catalogo') {
      firstLabel =
        allowedLabels.find(allowedLabel => allowedLabel !== 'Catalogo') || null;
    }

    secondLabel =
      allowedLabels.find(
        allowedLabel =>
          allowedLabel !== 'Catalogo' && allowedLabel !== firstLabel,
      ) || null;

    const hasDropdownMenu = configs.cloneCatalogOffer && onCloneButton;

    return (
      <div className={`Car${suggested ? ' suggested' : ''}`}>
        <div className="CarItem">
          <Card
            cover={ <a href={link} target="_blank" aria-label={`Vai al dettaglio dell'offerta ${brand} ${model}`}>
              <img src={image} alt={`Immagine ${ brand } ${ model }`} /></a>}
              >
              {status !== undefined && onStatusButton ? (
              <ToggleButton
                status={status}
                onClick={onStatusButton}
                dataAttribute={target}
                title="Modifica stato"
              />
            ) : null}
            <a href={link} target="_blank" aria-label={`Vedi offerta ${brand} ${model}`}>
              {monthlyRate !== undefined && (
                <div
                  className={`car-price-container text-right position-absolute w-50 ${
                    hasDropdownMenu ? 'has-dropdown-menu' : ''
                  }`}
                >
                  <div className="car-price">
                    &euro;
                    {monthlyRate}
                    <span className="car-price-desc">/mese</span>
                  </div>
                  <p className="car-price-vat">{messages.vat.defaultMessage}</p>

                  {typeof sustainabilityIndex == 'number' && (
                    <TrafficLights
                      className="prescoring-tool-offer-card px-1"
                      selected={[sustainabilityIndex]}
                      enabled={[sustainabilityIndex]}
                    />
                  )}
                </div>
              )}

              <div className="car-labels-container d-flex flex-column align-items-start">
                {firstLabel && <Tag className="car-label">{firstLabel}</Tag>}

                {secondLabel && (
                  <Tag className="car-label-secondary">{secondLabel}</Tag>
                )}
              </div>

              {hasDropdownMenu && (
                <div className="clone-btn-container">
                  <DropdownMenu
                    items={[
                      <a onClick={onCloneButton} aria-label={'Duplica offerta'}>
                        Duplica offerta
                      </a>,
                    ]}
                  />
                </div>
              )}

              <div className="car-name">
                {stockAvailability && stockAvailability !== '' ?
                <Tag className="car-label-tertiary position-absolute">Disponibilità: {stockAvailability}</Tag>
                : null}
                {isCustom && (
                  <i className="is-multi fa fa-bookmark"></i>
                )}
                {brand} {model}
                {reference_code && (
                  <span className="car-reference-code">{reference_code}</span>
                )}
                <span className="car-version">{version}</span>
                {color.length > 0 && <span className="car-color">{color}</span>}
              </div>
              {duration && (
                <div className="car-extra-info">
                  <ul>
                    <li>{duration} mesi</li>
                    <li>{distance.toLocaleString('it')} km/Anno</li>
                    <li>
                      <FormattedMessage
                        {...messages.deposit}
                        values={{deposit: deposit.toLocaleString('it')}}
                      />
                    </li>
                  </ul>
                </div>
              )}
            </a>
          </Card>
        </div>
      </div>
    );
  }
}

CarItem.defaultProps = {
  image: configs.cdnHost + '/cars/generic_shape.png',
  color: '',
  tag: '',
  secondary_tag: '',
  delivery_time_label: '',
  highlighted: false,
  suggested: false,
  sustainabilityIndex: null,
};

CarItem.propTypes = {
  image: PropTypes.string,
  brand: PropTypes.string,
  reference_code: PropTypes.string,
  model: PropTypes.string.isRequired,
  version: PropTypes.string,
  target: PropTypes.string,
  color: PropTypes.string,
  monthlyRate: PropTypes.number,
  tag: PropTypes.string,
  secondary_tag: PropTypes.string,
  stockAvailability: PropTypes.string,
  catalogSelected: PropTypes.bool,
  delivery_time_label: PropTypes.string,
  deposit: PropTypes.number,
  duration: PropTypes.number,
  distance: PropTypes.number,
  highlighted: PropTypes.bool,
  suggested: PropTypes.bool,
  isCustom: PropTypes.bool,
  isOwned: PropTypes.bool,
  sustainabilityIndex: PropTypes.number,
  link: PropTypes.string.isRequired,
};

export default CarItem;
